export const ANALYTICS_EVENT_NAMES = {
  integrationsBeginOauthConnect: 'integrations_begin_oauth_connect',
  integrationsConnectFailure: 'integrations_connect_failure',
  integrationsConnectSuccess: 'integrations_connect_success',
  integrationsFormSubmitError: 'integrations_form_submit_error',
  integrationsFormSubmitSuccess: 'integrations_form_submit_success',
  integrationsOauthConnectSuccess: 'integrations_oauth_connect_success',
  integrationsOpenDrawer: 'integrations_open_drawer',
  otcCreateSendSchedule: 'otc_create_send_schedule',
};

export const ERROR_PAGE_VIEW_EVENT = 'view_error_page';

export const DASHBOARD_ANALYTICS_EVENTS = {
  userLoggedIn: 'user_logged_in',
  userLoggedOut: 'user_logged_out',
};

export const MPARTICLE_EVENTS = {
  contentSaved: 'content_saved',
  entityAction: 'entity_action',
  selectX: 'select_x',
  toggle: 'toggle',
} as const;

// the one filter for the onboarding flow: on every onboarding event and page view, set nowhere else
export const ONBOARDING_SOURCE = 'onboarding_wizard';

export const POS_MENU_SETTINGS_SOURCE = 'pos_menu_settings';

export const ENTITY_TYPES = {
  campaign: 'campaign',
  category: 'category',
  integration: 'integration',
  item: 'item',
  menu: 'menu',
  modifier: 'modifier',
  modifierGroup: 'modifier_group',
  order: 'order',
} as const;

export const INTEGRATION_ACTIONS = {
  connected: 'connected',
  connectFailed: 'connect_failed',
  disconnected: 'disconnected',
  locationLinked: 'location_linked',
} as const;

export const CONNECTION_METHODS = {
  form: 'form',
  oauth: 'oauth',
  token: 'token',
} as const;

export const INTEGRATION_TYPES = {
  kds: 'kds',
  platform: 'platform',
  pos: 'pos',
} as const;

export const TOGGLE_TARGETS = {
  integrationMenuSync: 'integration_menu_sync',
  integrationOrders: 'integration_orders',
  menuAvailability: 'menu_availability',
  ordersAvailability: 'orders_availability',
} as const;

// normalizes inconsistent backend integrationType values
export const INTEGRATION_TYPE_MAP: Record<string, string> = {
  fresh_kds: INTEGRATION_TYPES.kds,
  platforms: INTEGRATION_TYPES.platform,
  pos: INTEGRATION_TYPES.pos,
};
